<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      轮船<br>
<a href="http://www.cmskchp.com/">深圳蛇口轮船</a><br><br>
购票须知<br>
<br>
【 国内航线 】<br>
<br>
1.学生票、军残票不在线上销售，如有需要请到蛇口邮轮中心二楼票务中心现场购票。<br><br>
2.免费婴儿票：年龄不超过1周岁（含1周岁）可购买免费婴儿票，请到蛇口邮轮母港二楼票务中心实名购买。<br><br>
3.免费小童票：1-6周岁（含6周岁）可购买免费小童票。<br><br>
4.每位成年旅客最多可购两张免费未成年人票，超出部分需购买儿童票。<br><br>
5.儿童票：6-14周岁（含14周岁）可购儿童票。<br><br>
6.长者票：年满65周岁（含65周岁）可购买长者票。（注意：外伶仃航线、东澳岛航线、桂山岛航线年满60周岁（含60周岁）即可购买长者票。）<br><br>
7.非以上年龄段旅客需购买全价票。<br><br>
8.每一旅客可免费携带总重量20公斤（免费儿童减半），总体积0.3立方米的行李 。每一件自带行李总重量不超过20公斤，0.2立方米，长度不超过1.5米（杆形物品2米），超过免费规定应购买行李票。乘快船每位旅客自带 行李一般不超过50公斤，0.3立方米。<br>
9.旅客应按所持船票指定的船名、航次、日期和座位乘船，重病人或精神病患者， 应有人护送。<br><br>
10.严禁旅客携带或托运违禁品，易燃、易爆、有毒、有腐蚀性、有放射性等危险品 ，有臭味、严腥 味物品、灵柩、尸体、尸骨上船。<br><br>
11.严禁旅客携带生或死的动物上船。<br><br>
12.船票当日当班有效，在票面时间60分钟（含）之前申请退票的，每张按票面金额的10%收取手续费；距票面时间不足60分钟申请退票的，每张按票面金额的15%收取手续费；开航后60分钟（含）内申请退票的，每张按票面金额的20%收取手续费；航班开航60分钟之后至票面时间24小时（含）申请退票的，每张按票面金额的30%收取手续费；a.线上退票的须在开航时间后24小时内办理退票，预期不予办理;b.因已取票等原因，需要通过人工客服协助，采用邮寄方式或港口票务中心现场办理退票的，需在开航时间后7个自然日内办理，逾期不予办理。<br><br>
13.来回程需提前15分钟到达登船闸口。<br><br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          // {
          //   name: "",
          //   title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>
